import INFTCollections from '../../models/INFTCollections'
import AvaxcellsCard from '../../nftFormats/Avaxcells/Card/AvaxcellsCard'
import AvaxcellsDetail from '../../nftFormats/Avaxcells/Detail/AvaxcellsDetail'
import AvaxcellsActivtyDetail from '../../nftFormats/Avaxcells/Activity/AvaxcellsActivityDetail'
import AvaxcellsLogo from '../../../../assets/nft-logo/Avaxcells.jpg'

export const AvaxcellsData: INFTCollections = {
  id: 'Avaxcells',
  tokenAddress: '0x2a3d2A525c293797cbD93DA689B35540bE2Fe631',
  name: 'Avaxcells',
  cardFormat: AvaxcellsCard,
  detailFormat: AvaxcellsDetail,
  activityFormat: AvaxcellsActivtyDetail,
  category: 2,
  creatorAddress: '0xce53F78748F7AC739A915Bb536bD38A6C49c9E0C',
  logo: AvaxcellsLogo,
  twitter: 'avaxcells',
  website: 'https://avaxcells.com/',
  telegram: 'https://t.me/joinchat/nrP0aVip7vVlMTMx'
}

export const AvaxcellsCategoryData = {
  [AvaxcellsData.tokenAddress.toLowerCase()]: AvaxcellsData.category
}
